import React from "react";
import { AlertInfo } from "../../../common/Alert";
import { FaTrash } from "react-icons/fa";
import Empty from "../../../../assets/images/appImages/category.png";
import { useAppDispatch, useAppSelector } from "../../../../redux/hook";
import { Color } from "../../../../utils/theme";
import Swal from "sweetalert2";
import {
  CartItemType,
  decrement,
  increment,
  removeCartItem,
} from "../../../../redux/slice/useCartSlice";
import { getImage, formatCurrency, formatDecimal } from "../../../../utils/Utils";
import { getVendeur } from "../../../HomePage/HomePage";



const CartItemCard = ({ cartItem }: { cartItem: CartItemType }) => {
  const Vendeur = getVendeur();
  const dispatch = useAppDispatch();
  let imgProd = "";
  if (cartItem?.produit.type === "taille_unique") {
    if (cartItem?.produit.id) {
      if (cartItem?.produit.images?.length) {
        imgProd = cartItem?.produit.images[0]?.image;
      } else {
        imgProd = "";
      }
    }
  } else {
    if (cartItem?.produit.variations?.length) {
      let variation = cartItem?.produit.variations[0];
      if (variation?.images?.length) {
        imgProd = cartItem?.produit.variations[0]?.images[0]?.image;
      } else {
        if (cartItem?.produit.images?.length) {
          imgProd = cartItem?.produit.images[0]?.image;
        } else {
          imgProd = "";
        }
      }
    }
  }

  // Fonction pour supprimer un produit du panier
  const supprimerDuPanier = async (produitASupprimer) => {
    await Swal.fire({
      title:
        "Êtes-vous sûr(e) de vouloir supprimer ce produit de votre panier ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
      showLoaderOnConfirm: true,
      iconColor: Color.themeColor,
      confirmButtonColor: Color.success,
      preConfirm: async () => {
        return await dispatch(removeCartItem(produitASupprimer));
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result: any) => {
      // console.log(result, "archiver");

      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: `Produit supprimé avec succès !`,
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  return (
    <div className="p-3 pb-2 cart_item__card">
      <div className="row custom-row">
        <div className="col-md-4 mb-3 custom-col">
          <div className="col-content product_name">
            <div className="d-flex align-items-center gap-2">
              <div className="product-image-container">
                <img
                  loading="lazy"
                  src={imgProd ? getImage(imgProd) : Empty}
                  alt="image"
                  className="cart-image"
                />
              </div>
              <div className="name-category-and-variation">
                <p className="product-name-panier mb-1">
                  {cartItem?.produit?.nom}
                </p>
                <p className="product-category-name mb-0">
                  {cartItem?.produit?.categorie?.nom}
                </p>
                <p className="product-category-name mb-0">
                  {cartItem?.produit?.variations[0] &&
                    cartItem?.produit?.variations[0]?.taille}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-2 mb-3 custom-col d-flex align-items-center">
          <div className="col-content product_price">
            <strong>{formatCurrency(cartItem?.prix, Vendeur?.devise)}</strong>
          </div>
        </div>
        <div className="col-md-2 mb-3 custom-col d-flex align-items-center">
          <div className="col-content product_qty">
            <p className="m-0 pb-2 d-block d-lg-none">Quantité</p>
            <div className="d-flex align-items-center justify-content-center">
              <div className="row-quantity d-flex">
                {cartItem?.quantite > 1 && (
                  <button
                    className="action-btn"
                    type="button"
                    onClick={() => dispatch(decrement(cartItem))}
                  >
                    {" "}
                    -
                  </button>
                )}
                <span className="qty_wrapper">{cartItem?.quantite}</span>
                {cartItem?.quantite < cartItem?.stock && (
                  <button
                    type="button"
                    className="action-btn"
                    onClick={() => dispatch(increment(cartItem))}
                  >
                    {" "}
                    +
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-2 mb-2 custom-col d-flex align-items-center">
          <div className="col-content product_total_price">
            <p className="m-0 pb-2 d-block d-lg-none">Total</p>
            <strong>
              {formatDecimal((cartItem?.prix * cartItem?.quantite), Vendeur?.devise)}
            </strong>
          </div>
        </div>
        <div className="col-md-2 mb-2 custom-col d-flex align-items-center justify-content-end">
          <div className="col-content delete_from_cart">
            <div className="container-btn-action-icon-modal">
              <button
                type="button"
                className="btn with-tooltip btn-action-icon-delete"
                data-tooltip-content="Supprimer"
                style={{ color: "#E53E3E" }}
                onClick={() => supprimerDuPanier(cartItem)}
              >
                <FaTrash />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


function PanierItemTable() {

  const { cartItems } = useAppSelector((state) => state.cart);

  return (
    <>
      <div className="row table-row">
        {cartItems?.length > 0 ? (
          cartItems?.map((item, key) => {
            return (
              <div className="col-md-12 col-lg-12 mb-2 col-item" key={key}>
                <CartItemCard cartItem={item} key={item?.produit?.id} />
              </div>
            )
          })
        ) : (
          <AlertInfo message="Votre panier est vide" />
        )}
      </div>
    </>
  );
}

export default PanierItemTable;